import React from 'react'
import { Enquiries, LightBulbIcon, PropertyDetails, PropertyReaches } from '../../../svg'

// import { Enquiries, LightBulbIcon, PropertyDetails, PropertyReaches } from '../svg';


const HowItWorks = () => {
    return (
        <div className='w-full pt-20 pb-8 pl-4 pr-4 '>
            <div className="w-full flex flex-col lg:flex-row items-center mb-8 justify-center lg:justify-start">
                <div className='relative z-20'>
                    {LightBulbIcon}
                </div>
                <div className="ml-4 lg:w-[70%]">
                    <h3 className="font-bold  text-[24px] lg:text-[28px] pb-px mt-2">How it works</h3>
                    <p className="text-[16px] text-gray-500 mt-1">Process behind this listing</p>
                </div>
            </div>

            <div className="flex flex-col">
                <div className="flex items-center mb-8">
                    <div className='relative z-20'>
                        {PropertyDetails}
                        <div className="absolute left-[50%] right-[50%] top-[88%] w-[2.5px] h-[5rem] bg-gray-300 z-10"></div>
                    </div>
                    <div className="ml-1 lg:ml-3 lg:w-[70%]">
                        <h3 className="font-bold text-[18px] pb-2">Provide Basic Details:</h3>
                        <p className="text-[16px] text-gray-500 lg:w-[80%]">Share essential details about your property, including its location, size, and preferred pricing.</p>
                    </div>
                </div>

                <div className="flex items-center mb-8">
                    <div className='relative z-20'>
                        {PropertyReaches}
                        <div className="absolute left-[50%] right-[50%] top-[88%] w-[2.5px] h-[5rem] bg-gray-300 z-10"></div>
                    </div>
                    <div className="ml-1 lg:ml-3 lg:w-[70%]">
                        <h3 className="font-bold text-[18px] pb-2 ">Reach Maximum Audience:</h3>
                        <p className="text-[16px] text-gray-500 lg:w-[80%]">Once listed, your property will be marketed to a large audience, reaching over 500,000 potential tenants.</p>
                    </div>
                </div>

                <div className="flex items-center mb-8">
                    <div className='relative z-20'>
                        {Enquiries}
                    </div>
                    <div className="ml-1 lg:ml-3 lg:w-[70%]">
                        <h3 className="font-bold text-[18px] pb-2">Start Receiving Inquiries:</h3>
                        <p className="text-[16px] text-gray-500 lg:w-[80%]">After your listing goes live, you’ll begin receiving inquiries from interested tenants.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HowItWorks